// extracted by mini-css-extract-plugin
module.exports = {"container":"_1JIhY0LL9CPq_7bK9IS8dU"};